@let definition = checklistDefinition();
<mat-card class="checklist-definition-detail-card">
  @if (displayHeader()) {
    <div class="detail-card-header checklist-definition-detail-card-header">
      <span whFlex="100" style="min-width: 0">
        <i
          mat-card-avatar
          class="workheld-icons header-icon"
          aria-hidden="true"
          [innerHtml]="checklistDefinitionIcon"
        ></i>
        <div class="header-content-wrapper">
          <div class="header-ext-id" [matTooltip]="definition?.extId">
            {{ definition?.extId }}
          </div>
          <div class="header-title" [matTooltip]="definition?.title">
            {{ definition?.title }}
          </div>
        </div>
      </span>
    </div>
  }

  <div class="checklist-definition-detail-card-body">
    @if (displayHeaderInBody()) {
      <div class="body-header">
        <div class="body-header-ext-id">{{ definition?.extId }}</div>
        <div class="body-header-title">{{ definition?.title }}</div>
      </div>
    }
    @if (definition?.description) {
      <p class="checklist-description">{{ definition.description }}</p>
    }

    <div class="check-definition-array-wrapper">
      <ng-bee-checklist-table
        [checks]="definition?.checkDefinitions"
        [sections]="definition?.sections"
      />
    </div>
  </div>

  @if (displayActionButtons()) {
    <div class="detail-actions-wrapper flex--r-c-sb">
      <w-h-back-button />
      <div class="flex--r-c gap--8">
        <w-h-button
          *appIsAllowed="{
            permission: 'flow.coordinator.checklist_template.create',
          }"
          [text]="
            'checklistdefinition.ui.duplicate.label' | translate | uppercase
          "
          matIcon="content_copy"
          type="stroked"
          [disabled]="statusUpdating()"
          (clicked)="copyChecklistDefinition()"
        />
        <w-h-button
          *appIsAllowed="{
            permission: 'flow.coordinator.checklist_template.delete',
          }"
          [text]="
            (isActive() ? 'app.deactivate.label' : 'app.activate.label')
              | translate
              | uppercase
          "
          [matIcon]="isActive() ? 'block' : 'check_circle'"
          type="stroked"
          [isLoading]="statusUpdating()"
          (clicked)="toggleStatus()"
        />
        <w-h-button
          *appIsAllowed="{
            permission: 'flow.coordinator.checklist_template.write',
          }"
          [text]="'app.edit.label' | translate | uppercase"
          matIcon="edit"
          color="accent"
          type="flat"
          [disabled]="statusUpdating()"
          (clicked)="editChecklistDefinition()"
        />
      </div>
    </div>
  }
</mat-card>
